import React from "react";
import Isotipo from "@/components/Isotipo";
import MockupShell from "./MockupShell";
import { NAV, HERO, WORLDS, WORK, METRICS, NEWS, CONTACT } from "./data";

const mont = { fontFamily: "Montserrat, sans-serif" };
const body = { fontFamily: "Manrope, sans-serif" };

const THEME = { bg: "#171726", text: "#F4F4F5", accent: "#edaa51", sub: "#26775e" };

const V1 = () => {
  return (
    <MockupShell theme={THEME}>
    <div data-testid="mockup-v1" className="min-h-screen" style={{ backgroundColor: "#171726", color: "#F4F4F5", ...body }}>
      {/* Header */}
      <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl" style={{ backgroundColor: "rgba(23,23,38,0.72)", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <Isotipo className="w-5 h-5" fill="#edaa51" />
            <span className="text-base font-extrabold tracking-tight" style={mont}>GRABARTE</span>
          </div>
          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <span key={n} className="text-[12px] font-medium uppercase tracking-[0.12em] cursor-default transition-colors hover:text-[#edaa51]" style={{ ...mont, color: "#A1A1AA" }}>{n}</span>
            ))}
          </nav>
          <div className="flex items-center gap-5">
            <span className="hidden sm:inline text-[11px] font-bold tracking-widest" style={{ ...mont, color: "#71717A" }}><span style={{ color: "#edaa51" }}>ES</span> / EN</span>
            <span className="inline-flex items-center rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] cursor-default" style={{ ...mont, border: "1px solid rgba(255,255,255,0.18)" }}>Hablemos</span>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="max-w-6xl mx-auto px-6 pt-40 pb-28">
        <p className="text-xs uppercase tracking-[0.3em] mb-8" style={{ ...mont, color: "#26775e" }}>{HERO.eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05] max-w-2xl" style={mont}>{HERO.title}</h1>
        <p className="mt-7 text-lg leading-relaxed max-w-xl" style={{ color: "#A1A1AA" }}>{HERO.sub}</p>
        <div className="mt-10 flex items-center gap-4">
          <span className="inline-flex items-center rounded-full px-6 py-3 text-xs font-bold uppercase tracking-[0.14em] cursor-default" style={{ ...mont, backgroundColor: "#edaa51", color: "#171726" }}>Ver proyectos</span>
          <span className="inline-flex items-center rounded-full px-6 py-3 text-xs font-bold uppercase tracking-[0.14em] cursor-default" style={{ ...mont, border: "1px solid rgba(255,255,255,0.18)", color: "#F4F4F5" }}>Servicios</span>
        </div>
      </section>

      {/* Dos mundos */}
      <section className="max-w-6xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-6" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        {WORLDS.map((w) => (
          <div key={w.id} className="rounded-sm p-8 transition-colors" style={{ backgroundColor: "rgba(30,30,48,0.6)", border: "1px solid rgba(38,119,94,0.2)" }}>
            <div className="rounded-sm overflow-hidden mb-7 aspect-[16/10]">
              <img src={w.image} alt={w.label} className="w-full h-full object-cover" style={{ filter: "grayscale(0.2)" }} />
            </div>
            <p className="text-[11px] uppercase tracking-[0.25em] mb-3" style={{ ...mont, color: "#26775e" }}>{w.label}</p>
            <h3 className="text-2xl font-bold tracking-tight" style={mont}>{w.line}</h3>
            <p className="mt-3 text-sm leading-relaxed" style={{ color: "#A1A1AA" }}>{w.desc}</p>
          </div>
        ))}
      </section>

      {/* Work */}
      <section className="max-w-6xl mx-auto px-6 py-24" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="flex items-end justify-between mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight" style={mont}>Proyectos seleccionados</h2>
          <span className="text-[11px] uppercase tracking-[0.2em]" style={{ ...mont, color: "#71717A" }}>2010 — 2026</span>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WORK.map((p) => (
            <div key={p.title} className="group">
              <div className="rounded-sm overflow-hidden aspect-[4/3] mb-4" style={{ border: "1px solid rgba(255,255,255,0.06)" }}>
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" style={{ filter: "grayscale(0.15)" }} />
              </div>
              <p className="text-[10px] uppercase tracking-[0.22em]" style={{ ...mont, color: "#26775e" }}>{p.kicker}</p>
              <h3 className="mt-1.5 text-base font-semibold" style={mont}>{p.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Metrics */}
      <section className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6" style={{ borderTop: "1px solid rgba(255,255,255,0.06)", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        {METRICS.map((m) => (
          <div key={m.label}>
            <p className="text-3xl sm:text-4xl font-bold tracking-tight" style={{ ...mont, color: "#edaa51" }}>{m.value}<span style={{ color: "#F4F4F5" }}>{m.suffix}</span></p>
            <p className="mt-2 text-xs leading-snug" style={{ color: "#A1A1AA" }}>{m.label}</p>
          </div>
        ))}
      </section>

      {/* News */}
      <section className="max-w-6xl mx-auto px-6 py-24">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-10" style={mont}>Actualidad</h2>
        <div>
          {NEWS.map((n) => (
            <div key={n.title} className="py-6 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-8" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
              <span className="text-[11px] uppercase tracking-[0.2em] shrink-0 w-40" style={{ ...mont, color: "#26775e" }}>{n.meta}</span>
              <span className="text-base sm:text-lg" style={{ color: "#F4F4F5" }}>{n.title}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section className="max-w-6xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-12 items-center" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] mb-6" style={{ ...mont, color: "#26775e" }}>Contacto</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight max-w-md" style={mont}>Hablemos de tu proyecto</h2>
        </div>
        <div className="space-y-5 text-lg">
          <p><span className="block text-[11px] uppercase tracking-[0.2em] mb-1" style={{ ...mont, color: "#71717A" }}>Email</span>{CONTACT.email}</p>
          <p><span className="block text-[11px] uppercase tracking-[0.2em] mb-1" style={{ ...mont, color: "#71717A" }}>Teléfono</span>{CONTACT.phone}</p>
          <p><span className="block text-[11px] uppercase tracking-[0.2em] mb-1" style={{ ...mont, color: "#71717A" }}>Dirección</span>{CONTACT.address}</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="max-w-6xl mx-auto px-6 py-10 flex items-center justify-between" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="flex items-center gap-2"><Isotipo className="w-4 h-4" fill="#edaa51" /><span className="text-sm font-bold tracking-tight" style={mont}>GRABARTE</span></div>
        <span className="text-xs" style={{ color: "#71717A" }}>© 2026 Grabarte · Madrid</span>
      </footer>

    </div>
    </MockupShell>
  );
};

export default V1;
